














import _ from 'lodash'
import moment from 'moment'
import {Component, Vue} from 'vue-property-decorator'
import {Action, Mutation} from 'vuex-class'
import {Task} from '@/store/types'
import SurveyModel from '@/classes/SurveyModel'
import TimeService from '@/classes/TimeService'

@Component({})
export default class SurveyTimer extends Vue {
  @Action('getTaskList') public getTaskList: any
  @Mutation('setSurveyInProgress') public setSurveyInProgress: any

  public timeInterval: any = null
  public time: number = 0
  public task: any = {}

  public get hasTaskInProgress() {
    return !_.isEmpty(this.task)
  }

  public created() {
    this.getTaskList([`status=${SurveyModel.STATUS.IN_PROGRESS}`])
      .then((response: Task[]) => {
        if (!!response[0]) {
          this.task = response[0]
          this.clockTick()
          this.setSurveyInProgress(true)
          return
        }
        this.setSurveyInProgress(false)
      })
  }

  public get timeDuration() {
    const time = moment.duration(this.time, 'seconds')
    return (time.hours() <= 9 ? '0' + time.hours() : time.hours())
      + ':' + (time.minutes() <= 9 ? '0' + time.minutes() : time.minutes())
      + ':' + (time.seconds() <= 9 ? '0' + time.seconds() : time.seconds())
  }

  public clockTick() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
    this.time = TimeService.diff(this.task.started_at, this.task.completed_at)
    if ( this.task.status === SurveyModel.STATUS.IN_PROGRESS ) {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
      this.timeInterval = setInterval(() => {
        this.time++
      }, 1000)
    }
  }

  public goToTask() {
    this.$router.push(`/survey/${this.task.id}`)
  }
}
